import { render } from "./orderusedrecord.vue?vue&type=template&id=65763ea0"
import script from "./orderusedrecord.vue?vue&type=script&lang=ts"
export * from "./orderusedrecord.vue?vue&type=script&lang=ts"
script.render = render

export default script